const ukFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

function ukParts(timestamp) {
  return Object.fromEntries(ukFormatter.formatToParts(new Date(timestamp))
    .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
}

export function nextUkMidnight(timestamp) {
  const current = ukParts(timestamp);
  const target = Date.UTC(current.year, current.month - 1, current.day + 1);
  let candidate = target;
  for (let pass = 0; pass < 3; pass += 1) {
    const local = ukParts(candidate);
    const represented = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
    candidate += target - represented;
  }
  return candidate;
}

export function remainingParts(timestamp, deadline = nextUkMidnight(timestamp)) {
  const total = Math.max(0, Math.ceil((deadline - timestamp) / 1000));
  return [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60]
    .map(value => String(value).padStart(2, '0'));
}

if (typeof customElements !== 'undefined' && !customElements.get('pfy-delivery-timer')) {
  customElements.define('pfy-delivery-timer', class extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-clock]');
      this.fallback = this.querySelector('[data-fallback]');
      this.digits = ['hours', 'minutes', 'seconds'].map(part => this.querySelector(`[data-${part}]`));
      if (!this.clock || this.digits.some(digit => !digit)) return;
      this.refresh = () => { this.deadline = nextUkMidnight(Date.now()); this.tick(); };
      this.tick = () => {
        const now = Date.now();
        if (!this.deadline || now >= this.deadline || this.lastNow > now) this.deadline = nextUkMidnight(now);
        this.lastNow = now;
        remainingParts(now, this.deadline).forEach((value, index) => {
          if (this.digits[index].textContent !== value) this.digits[index].textContent = value;
        });
        this.clock.hidden = false;
        if (this.fallback) this.fallback.hidden = true;
      };
      this.tick();
      clearInterval(this.interval);
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
  });
}
